import { GameMode } from '@/types/api.generated';

import { useBetslipStore } from './use-betslip-store';

export const useEntryAmount = (gameMode: GameMode) => {
    const plays = useBetslipStore(state => state.plays);
    return plays[gameMode]?.amount;
};
